import React from 'react';
import PropTypes from 'prop-types';
import EmptyState from './EmptyState';
import { PrimaryButton } from '../buttons';
import { GlobeIcon } from '../../icons';

/**
 * NetworkErrorState
 *
 * A friendly, reusable empty-state for network failures.
 */
const NetworkErrorState = ({
  title = 'Network error :(',
  description = "We couldn't load this right now. Please check your connection and try again.",
  onRetry = null,
  retryLabel = 'Try again',
  className = '',
  ...props
}) => {
  const icon = (
    <GlobeIcon size="3xl" color="neutral" aria-hidden="true" />
  );

  return (
    <EmptyState
      icon={icon}
      title={title}
      description={description}
      action={
        typeof onRetry === 'function' ? (
          <PrimaryButton size="sm" onClick={onRetry}>
            {retryLabel}
          </PrimaryButton>
        ) : null
      }
      className={className}
      {...props}
    />
  );
};

NetworkErrorState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onRetry: PropTypes.func,
  retryLabel: PropTypes.string,
  className: PropTypes.string,
};

export default NetworkErrorState;


